<template>
  <div class="mt-5 mx-5 px-5">
    <v-layout v-if="!loadingValidando && tempoMinimoDecorrido">
      <v-flex style="text-align: center">
        <span v-if="situacaoCodigo === 'VALIDO'" class="area-sucesso">
          <check-icon-animated status="SUCESSO"></check-icon-animated>
          <span class="mensagem-resultado-validacao-email">
            Maravilha! E-mail validado com sucesso.
            <br>
            <span class="texto-secundario-mensagem">
              Para visualizar o esclarecimento ou impugnação cadastrado, confira a listagem na nossa página.
              <br>
              Você já pode fechar esta página.
            </span>
          </span>
        </span>
        <span v-if="situacaoCodigo === 'CONFIRMADO'" class="area-confirmado">
          <check-icon-animated status="SUCESSO"></check-icon-animated>
          <span class="mensagem-resultado-validacao-email">
            Este e-mail já foi validado anteriormente!
            <br>
            <span class="texto-secundario-mensagem">
              Está tudo certo. Você já pode fechar esta página.
              <br>
              <span>
                Caso o esclarecimento/impugnação criado não esteja aparecendo na lista
                <br>
                por favor realize uma nova solicitação, ou entre em contato pelos numeros:
                <br>
                <span class="telefone">(67) 3303-2730</span> e <span class="telefone">(67) 3303-2702</span>
              </span>
            </span>
          </span>
        </span>
        <span v-if="situacaoCodigo === 'EXPIRADO' || situacaoCodigo === 'INVALIDO'" class="area-expirado">
          <check-icon-animated status="ERRO"></check-icon-animated>
          <span class="mensagem-resultado-validacao-email">
            Ops! Parece que o link não é mais válido.
            <br>
            <span class="texto-secundario-mensagem">
              Será necessário realizar uma nova solicitação de esclarecimento/impugnação.
            </span>
            <br>
            <span class="dica">
              Dica: Acesse o novo link dentro de 4 horas, pois após esse tempo ele será desativado!
            </span>
          </span>
        </span>
        <span v-if="situacaoCodigo === 'ERRO'" class="area-erro">
          <check-icon-animated status="ERRO"></check-icon-animated>
          <span class="mensagem-resultado-validacao-email">
            Ops! Houve um erro na validação do link.
            <br>
            <span class="texto-secundario-mensagem">
              Por favor tente realizar uma nova solicitação
              <br>
              Ou entre em contato com o suporte pelos números oficiais:
              <br>
              <span class="telefone">(67) 3303-2730</span>
              e
              <span class="telefone">(67) 3303-2702</span>
            </span>
          </span>
        </span>
      </v-flex>
    </v-layout>
    <v-layout v-else>
      <v-flex style="text-align: center">
        <span class="area-loading">
          <check-icon-animated status="LOADING"></check-icon-animated>
          <span class="mensagem-resultado-validacao-email">
            Realizando validação... Aguarde!
          </span>
        </span>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import {actionTypes} from '@/core/constants'

export default{
    name: 'ValidarCodigoEmail',
    data(){
        return{
            codigoValidar: null,
            situacaoCodigo: null,
            loadingValidando: null,
            tempoMinimoDecorrido: false
        }
    },
    mounted(){
        this.getCodigoParam()
        this.validarCodigo()
    },
    methods:{
        async validarCodigo(){
            this.loadingValidando = true
            try {
                const resultado = await this.$store.dispatch(actionTypes.VALIDAR_CODIGO_EMAIL, this.codigoValidar)
                this.situacaoCodigo = resultado.tokenSituacao
                this.loadingValidando = false
            }catch(erro){
                this.situacaoCodigo = 'ERRO'
                this.loadingValidando = false
            }
        },
        atribuirTempoMinimoDecorrido(){
            this.tempoMinimoDecorrido = true
        },
        getCodigoParam(){
            this.codigoValidar = this.$route.params.codigo
        },
    },
    timers:{
        atribuirTempoMinimoDecorrido:{
            time: 5000,
            repeat: false,
            autostart: true
        }
    }
}
</script>
<style lang="stylus">
.mensagem-resultado-validacao-email
  font-size large !important
  font-weight bold
  line-height 1 !important

  .texto-secundario-mensagem
    font-size 0.75em !important

  .dica
    font-weight normal
    font-size 0.6em !important

  .telefone
    line-height 2
    font-weight bolder
    color black

</style>